/**
 * Dealer profile contact attribution (Dealer Profile M9).
 */

export const DEALER_PROFILE_SOURCE_PAGE = "dealer_profile";

export const DEALER_PROFILE_SOURCE_COMPONENTS = {
  HERO: "dealer_profile_hero",
  TRUST_PANEL: "dealer_profile_trust_panel",
  CONTACT_CARD: "dealer_profile_contact_card",
  INVENTORY_GRID: "dealer_inventory_grid",
  INVENTORY_CARD: "dealer_inventory_card",
  MOBILE_CTA: "dealer_profile_mobile_cta",
};

export const DEALER_PROFILE_SOURCE_ACTIONS = {
  DEALER_WHATSAPP_CLICK: "dealer_whatsapp_click",
  DEALER_PHONE_CLICK: "dealer_phone_click",
  DEALER_PROFILE_CONTACT_CLICK: "dealer_profile_contact_click",
  INVENTORY_VEHICLE_CONTACT_CLICK: "dealer_inventory_vehicle_contact_click",
  CONTACT_DISABLED_CLICK: "dealer_profile_contact_disabled_click",
};

export const DEALER_PROFILE_CONTACT_METHODS = {
  WHATSAPP: "whatsapp",
  PHONE: "phone",
  PROFILE: "profile",
  UNKNOWN: "unknown",
};

export const DEALER_PROFILE_LEAD_TYPES = {
  DEALER_PROFILE_CONTACT: "dealer_profile_contact",
  VEHICLE_LISTING_CONTACT: "vehicle_listing_contact",
};

export const DEALER_PROFILE_CONTACT_ANALYTICS_EVENTS = {
  CONTACT_CLICKED: "dealer_profile_contact_clicked",
  WHATSAPP_CLICKED: "dealer_profile_whatsapp_clicked",
  PHONE_CLICKED: "dealer_profile_phone_clicked",
  CONTACT_DISABLED_CLICKED: "dealer_profile_contact_disabled_clicked",
  LEAD_CREATED: "dealer_profile_lead_created",
  LEAD_CREATE_FAILED: "dealer_profile_lead_create_failed",
  INVENTORY_VEHICLE_CONTACT_CLICKED: "dealer_inventory_vehicle_contact_clicked",
  INVENTORY_VEHICLE_WHATSAPP_CLICKED: "dealer_inventory_vehicle_whatsapp_clicked",
  INVENTORY_VEHICLE_LEAD_CREATED: "dealer_inventory_vehicle_lead_created",
  INVENTORY_VEHICLE_LEAD_CREATE_FAILED: "dealer_inventory_vehicle_lead_create_failed",
};

/** Reuse duplicate guard window from vehicle contact flow. */
export { LEAD_DUPLICATE_WINDOW_MS } from "./automapDealerTrustConstants";
